import PagerItem from './PagerItem';
import deprecationWarning from './utils/deprecationWarning';
export default deprecationWarning.wrapper(PagerItem, '`<PageItem>`', '`<Pager.Item>`');


//////////////////
// WEBPACK FOOTER
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/node_modules/react-bootstrap/es/PageItem.js
// module id = 390
// module chunks = 0 1 2 3 4 5 6